import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Calendar, CheckSquare, ArrowRight} from 'lucide-react';
import Card from '../components/UI/Card';

const Landing = () => {
  const { t } = useTranslation();

  const features = [
    {
      icon: Calendar,
      title: t('landing.calendar.title'),
      description: t('landing.calendar.description'),
      link: '/listings',
      color: 'from-blue-500 to-cyan-500',
    },
    {
      icon: CheckSquare,
      title: t('landing.checklist.title'),
      description: t('landing.checklist.description'),
      link: '/cleaning-listings',
      color: 'from-purple-500 to-pink-500',
    },
  ];



  return (
    <div className="min-h-screen">
      {/* Features Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto text-center">
          <div className="animate-fade-in">
            <h1 className="text-5xl md:text-7xl font-bold mb-6">
              <span className="text-gradient">{t('landing.title')}</span>
            </h1>
          </div>
        </div>
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <p className="text-xl text-gray-400 max-w-2xl mx-auto">
              {t('landing.tagline')}
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {features.map((feature, index) => {
              const Icon = feature.icon;
              return (
                <Card
                  key={index}
                  hover
                  glow
                  glass
                  className="p-8 group"
                >
                  <div className="flex items-start space-x-6">
                    <div className={`p-4 rounded-xl bg-gradient-to-r ${feature.color} shadow-lg`}>
                      <Icon className="w-8 h-8 text-white" />
                    </div>
                    <div className="flex-1">
                      <h3 className="text-2xl font-bold text-white mb-3 group-hover:text-blue-400 transition-colors">
                        {feature.title}
                      </h3>
                      <p className="text-gray-400 mb-4 leading-relaxed">
                        {feature.description}
                      </p>
                      <div className="flex items-center justify-end">
                        <Link
                          to={feature.link}
                          className="inline-flex items-center space-x-2 text-blue-400 hover:text-blue-300 transition-colors"
                        >
                          <span>Explore</span>
                          <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                        </Link>
                      </div>
                    </div>
                  </div>
                </Card>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Landing;
